export default __webpack_public_path__ + "static/media/fa-solid-900.ada6e6df.woff2";